import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  SpecialInvoiceActionTypes,
  SpecialInvoiceActions,
} from '@ordersnproducts/modules/new-modify-order/actions/special-invoice.actions';

export interface SpecialInvoiceState {
  specialInvoice: boolean;
}

export const initialState: SpecialInvoiceState = {
  specialInvoice: false,
};

export function reducer(
  state = initialState,
  action: SpecialInvoiceActions | OrderBuilderActions,
): SpecialInvoiceState {
  switch (action.type) {
    case SpecialInvoiceActionTypes.SET_SPECIAL_INVOICE: {
      return {
        ...state,
        specialInvoice: action.payload,
      } as SpecialInvoiceState;
    }
    case RESET_BUILDER:
    case SpecialInvoiceActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
